import { tv } from 'tailwind-variants';

export const tabItemStyle = tv({
  base: 'items-center text-sm pb-2 transition-colors duration-300 text-gray-600',
  variants: {
    orientation: {
      vertical:
        'grid grid-cols-[75px_1fr] justify-center py-2 my-2 w-full text-secondary-fixxer-two hover:border-secondary-fixxer-two hover:text-secondary-fixxer-two border-r-[3px]',
      horizontal: 'grid justify-center border-b-[3px] border-gray-600',
    },
    design: {
      primary:
        'text-primaryFixxer-one hover:border-primaryFixxer-one hover:text-primaryFixxer-one',
      'secondary-dark':
        'text-secondary-two hover:border-secondary-two hover:text-secondary-two',
    },
    textTransform: {
      uppercase: 'uppercase',
      capitalize: 'capitalize',
      lowercase: 'lowercase',
    },
    selected: {
      true: 'opacity-100',
      false: 'opacity-80',
    },
    iconPosition: {
      top: 'gap-y-1 justify-center',
      left: 'grid-cols-[auto_1fr]',
      right: 'flex flex-row-reverse grid-cols-[auto_70px]',
    },
    iconOnly: {
      true: 'text-[0]',
    },
    common: {
      true: '',
    },
    disabled: {
      true: 'opacity-20',
    },
  },
  defaultVariants: {
    design: 'secondary-dark',
    orientation: 'horizontal',
    textTransform: 'uppercase',
    size: 'md',
  },
  compoundVariants: [
    {
      design: 'primary',
      selected: true,
      className: 'border-primaryFixxer-one',
    },
    {
      design: 'secondary-dark',
      selected: true,
      orientation: 'horizontal',
      className:
        'text-primaryFixxer-one border-b-primaryFixxer-one font-bold hover:border-primaryFixxer-one hover:text-primaryFixxer-one',
    },
    {
      design: 'secondary-dark',
      orientation: 'vertical',
      selected: true,
      className:
        'text-white border-r-primaryFixxer-one font-bold hover:border-primaryFixxer-one hover:text-white bg-primaryFixxer-one rounded-xl rounded-r-none',
    },
    {
      design: 'secondary-dark',
      orientation: 'vertical',
      common: false,
      selected: false,
      className:
        'text-secondary-one border-r-secondary-one font-bold hover:border-primaryFixxer-one hover:text-primaryFixxer-one bg-blue-50 rounded-xl rounded-r-none',
    },
    {
      design: 'secondary-dark',
      orientation: 'vertical',
      common: true,
      selected: false,
      className:
        'flex-row-reverse text-secondary-one font-bold border-r-0 hover:text-primaryFixxer-one bg-blue-50 rounded-xl rounded-r-none',
    },
  ],
});
